import { CardPanel, Row, Col } from 'react-materialize';

const Video = () => {
    return (
        <Row>
            <h1>Videography</h1>
            <CardPanel className="black panel">
                <Row>
                    <Col s={12} m={5} l={5}>
                        <h3>
                            I am Rein. I do video.
                        </h3>
                    </Col>
                    <Col s={12} m={7} l={7}>
                        <video
                            width="100%"
                            controls
                            autoPlay
                            loop
                        >
                            <source src='/vid/stick-swinger.mp4' type="video/mp4" />
                            <source src='/vid/stick-swinger.mov' type="video/quicktime" />
                            Your Browser does not support this video type.
                        </video>
                    </Col>
                </Row>
            </CardPanel>
        </Row>
    )
};

export default Video;